import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=7152a52a&scoped=true&"
var script = {}
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=7152a52a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7152a52a",
  null
  
)

export default component.exports